import "reflect-metadata";
import { lazy } from "react";
import { injectable, registry } from "tsyringe";
import { FeatureSetupDef, FeatureRootRoute, FeatureSetup } from "@app/types/feature.types";

import { version, name } from "@feature/package.json";
import { FeatureToken } from "@app/constants/di";
import { featurePaths } from "@feature/constants/paths.constant";

const EmailTemplateListPage = lazy(() => import("@feature/pages/EmailTemplateList"));
const CreateEmailTemplatePage = lazy(() => import("@feature/pages/CreateEmailTemplate"));
const FormTemplateListPage = lazy(() => import("@feature/pages/FormTemplateList"));
const CreateFormTemplatePage = lazy(() => import("@feature/pages/CreateFormTemplate"));
const UpdateFormTemplatePage = lazy(() => import("@feature/pages/UpdateFormTemplate"));
const FormSummaryPage = lazy(() => import("@feature/pages/FormSummary"));
const FormAllocationPage = lazy(() => import("@feature/pages/FormAllocation"));
const SendLoginDetailsPage = lazy(() => import("@feature/pages/SendLoginDetails"));
const FormSubmissionListPage = lazy(() => import("@feature/pages/FormSubmissionList"));
const ApproveFormSubmissionPage = lazy(() => import("@feature/pages/ApproveFormSubmission"));
const SubmitFormPage = lazy(() => import("@feature/pages/SubmitForm"));
const FormSubmissionPage = lazy(() => import("@feature/pages/FormSubmission"));
const FormBuilderPage = lazy(() => import("@feature/pages/FormBuilder"));
const FormSubmitPage = lazy(() => import("@feature/pages/FormSubmit"));
const UpdateFormSubmissionPage = lazy(() => import("@feature/pages/EditFormSubmission"));
const FormInfoSectionPage = lazy(() => import("@feature/pages/FormInfoSection"));


@injectable()
@registry([{ token: FeatureToken, useClass: FormTemplate }])
class FormTemplate implements FeatureSetupDef {
  GetFeatureSetup(): FeatureSetup {
    return {
      version,
      namespace: name,
      featuresRoot: this.features,
      permissions: [],
      index: true
    };
  }

  private readonly features: FeatureRootRoute = {
    requiredPermissions: [],
    children: [
      {
        title: "Email Template List",
        path: featurePaths.EmailTemplateList,
        page: EmailTemplateListPage
      },
      {
        title: "Create Email Template",
        path: featurePaths.CreateEmailTemplate,
        page: CreateEmailTemplatePage
      },
      {
        title: "Form Template List",
        path: featurePaths.FormTemplate,
        page: FormTemplateListPage
      },
      {
        title: "Create Form Template",
        path: featurePaths.CreateFormTemplate,
        page: CreateFormTemplatePage
      },
      
      {
        title: "Update Form Template",
        path: featurePaths.UpdateFormTemplate,
        page: UpdateFormTemplatePage
      },
      
      {
        title: "Form Allocation",
        path: featurePaths.FormAllocation,
        page: FormAllocationPage
      },
      {
        title: "Form Summary",
        path: featurePaths.FormSummary,
        page: FormSummaryPage
      },
      {
        title: "Send Login Details",
        path: featurePaths.SendLoginDetails,
        page: SendLoginDetailsPage
      },
      {
        title: "Form Submission List",
        path: featurePaths.FormSubmissionList,
        page: FormSubmissionListPage
      },
      {
        title: "Approve Form Submission",
        path: featurePaths.ApproveFormSubmission,
        page: ApproveFormSubmissionPage
      },
      {
        title: "Submit Form",
        path: featurePaths.SubmitForm,
        page: SubmitFormPage
      },
      {
        title: "Form Submission",
        path: featurePaths.FormSubmission,
        page: FormSubmissionPage
      },
      {
        title: "Form Builder",
        path: featurePaths.FormBuilder,
        page: FormBuilderPage
      },
      {
        title: "Form Submit",
        path: featurePaths.FormSubmit,
        page: FormSubmitPage
      },
      {
        title: "Update Form Submission",
        path: featurePaths.UpdateFormSubmission,
        page: UpdateFormSubmissionPage
      },
      {
        title: "Form Info Section",
        path: featurePaths.FormInfoSection,
        page: FormInfoSectionPage
      }
    ]
  };
}

export default FormTemplate;
